import { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import AcedSelect, {
  SelectOption,
  SelectOptions,
} from "../../../components/essentials/input/select/AcedSelect";
import http from "../../../shared/utils/http";

export interface SelectStaffProps {
  label: string;
}
const SelectStaff: React.FC<SelectStaffProps> = ({ label }) => {
  const { t } = useTranslation();
  const { control } = useFormContext();
  const [staffRoles, setStaffRoles] = useState<SelectOptions>([]);

  useEffect(() => {
    http.get("/utils/staff").then((response) => {
      setStaffRoles(
        response.map(
          (value: string) =>
            ({
              value,
              label: t("sportData.positions.staff." + value),
            } as SelectOption)
        )
      );
    });
  }, []);

  return (
    <AcedSelect
      label={label}
      options={staffRoles}
      control={control}
      name="position"
      placeholder={t("createJob.placeholder.select")}
      rules={{ required: t("createJob.validation.required") }}
    />
  );
};

export default SelectStaff;
